var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    rx: 2,
    fill: "#5062F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.84674 3.13976C10.0457 3.33125 10.0517 3.64778 9.86024 3.84673L5.04774 8.84674C4.95349 8.94466 4.82342 9 4.6875 9C4.55158 9 4.42151 8.94466 4.32726 8.84674L2.13976 6.57401C1.94826 6.37505 1.95431 6.05853 2.15327 5.86703C2.35222 5.67553 2.66875 5.68158 2.86024 5.88054L4.6875 7.77899L9.13976 3.15327C9.33125 2.95431 9.64778 2.94826 9.84674 3.13976Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxIcon);
export default __webpack_public_path__ + "static/media/checkboxIcon.95e140c5ceb3f40d74692b7067cd7c94.svg";
export { ForwardRef as ReactComponent };